import { render, staticRenderFns } from "./DashboardBuilder.vue?vue&type=template&id=800d2592&scoped=true&"
import script from "./DashboardBuilder.vue?vue&type=script&lang=js&"
export * from "./DashboardBuilder.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBuilder.vue?vue&type=style&index=0&id=800d2592&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800d2592",
  null
  
)

export default component.exports